import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  taskColumnsOrder : ["Task Name", "Project manager", "Assignee", "Time Tracking",
    "Priority", "Time Estimate", "Task Flow", "Status", "Pipeline", "Description",
    "Sequence No.", "Start Date", "End Date", "Transitions", "Created On", "Completion Date",
    "Latest Activity", "Attachments", "Comments", "Latest Comments", "Milestone", "Status Date", "SLA"],
  timeTrackFlag: false, // timeTrackClock from TrackTimeRemChatSection.jsx used as timeTrackFlag in task.jsx
  triggerStartStop: {
  flag: false,
  payload: null,
},
  timerObj: null,
  timerPrevTimeTrack: 0,
  timerTimeTrack: 0,
  initializeTimeTrackFlag: null,
};

const timeTrackingSlice = createSlice({
  name: 'TimeTrackingSlice',
  initialState,
  reducers: {
    setTimeTrackFlag: (state, action) => {
      state.timeTrackFlag = action.payload;
    },
    setTriggerStartStop: (state, action) => {
    state.triggerStartStop = {
        flag: action.payload.flag,
        payload: action.payload.payload,
    };
    },
    resetTriggerStartStop: (state) => {
    state.triggerStartStop = {
        flag: false,
        payload: null,
    };
    }, 
    settimerObj: (state, action) => {
      state.timerObj = action.payload;
    },
    setTimerPrevTimeTrack: (state, action) => {
      state.timerPrevTimeTrack = action.payload;
    },
    settimerTimeTrack: (state, action) => {
      state.timerTimeTrack = action.payload;
    },
    setInitializeTimeTrackFlag: (state, action) => {
      state.initializeTimeTrackFlag = action.payload;
    },
    setTaskColumnsOrder: (state, action) => {
      state.taskColumnsOrder = action.payload;
    },
  },
});

export const {
  setTimeTrackFlag,
  setTriggerStartStop,
  resetTriggerStartStop,
  settimerObj,
  setTimerPrevTimeTrack,
  settimerTimeTrack,
  setInitializeTimeTrackFlag,
  setTaskColumnsOrder
} = timeTrackingSlice.actions;

export default timeTrackingSlice.reducer;
